import { render } from "./Offenlegung.vue?vue&type=template&id=752b09e6"
import script from "./Offenlegung.vue?vue&type=script&lang=ts"
export * from "./Offenlegung.vue?vue&type=script&lang=ts"

import "./Offenlegung.vue?vue&type=style&index=0&id=752b09e6&lang=scss"
script.render = render

export default script